import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools';

const Card = {
  baseStyle: (props: StyleFunctionProps) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    position: 'relative',
    borderRadius: 'sm',
    minWidth: '0px',
    wordWrap: 'break-word',
    bg: mode('white', 'gray.800')(props),
    backgroundClip: 'border-box',
    textColor: mode('black', 'white')(props),
    minW: 'xs',
    padding: '4',
    border: '1px solid',
    borderColor: mode('gray.100', 'gray.700')(props),
  }),
  variants: {
    rounded: {
      borderRadius: 'xl',
      boxShadow: 'md',
    },
    smooth: {
      boxShadow: 'base',
    },
    shadow: {
      shadow: 'lg',
    },
    ghost: {
      border: 'none',
    },
  },
  defaultProps: {
    variant: 'smooth',
  },
};

export default Card;
